// The second list.
//
// A separate object from the table, and it reads as one. There are no seller
// columns here: impression share, leak stage and effectiveness all read the
// seller's own counts, and on these terms those counts do not exist. Showing
// them as zero would say the seller is losing a term they were never in.
import React from 'react';
import s from '../KeywordPerformance.module.css';
import { num, pct } from '../format';

export default function AbsentList({ data, loading }) {
  if (loading) return <div className={s.empty}>Loading…</div>;
  if (!data) return null;
  if (data.message) return <div className={s.empty}>{data.message}</div>;
  if (!data.rows?.length) {
    return <div className={s.empty}>No terms in your categories that you are absent from.</div>;
  }

  const sum = data.summary;
  return (
    <>
      <p className={s.hint} style={{ marginBottom: 12 }}>
        {num(sum.total)} terms in your categories where none of your products received a
        single impression — {num(sum.competitor_wins_it)} held by a competitor you named,{' '}
        {num(sum.nobody_named_wins_it)} by nobody you track
        {!sum.split_covers_all && ' (counted over the rows listed below)'}. Found by scanning{' '}
        {num(sum.market_terms_searched)} marketplace terms and keeping the ones that match
        your catalogue&apos;s vocabulary. {sum.basis}
      </p>

      {sum.data_mismatch?.length > 0 && (
        <p className={s.notice}>
          {sum.data_mismatch.length} terms were excluded as a data error: one of your own
          ASINs holds a top-three slot on them, so they cannot be terms you are absent from.
        </p>
      )}

      <div className={s.tableWrap}>
        <table className={s.table}>
          <thead>
            <tr>
              <th>Keyword</th>
              <th className={s.right}>Search rank</th>
              <th className={s.right}>Top-3 hold</th>
              <th>Who wins it</th>
              <th>Split</th>
            </tr>
          </thead>
          <tbody>
            {data.rows.map((r) => (
              <tr key={r.search_term}>
                <td><span className={s.term}>{r.search_term}</span></td>
                <td className={s.right}>{r.rank == null ? '—' : `#${num(r.rank)}`}</td>
                <td className={s.right}>{pct(r.concentration, 0)}</td>
                <td>
                  <ul className={s.holdersInline}>
                    {(r.holders || []).map((h) => (
                      <li key={h.asin}>
                        <span className={h.competitor ? s.holderRival : s.holderOther}>
                          {h.asin}
                        </span>
                        {h.competitor && <span className={s.tagRival}>{h.competitor}</span>}
                        <span className={s.muted}> {pct(h.click_share, 0)}</span>
                      </li>
                    ))}
                  </ul>
                </td>
                <td>
                  <span className={r.competitor ? s.leakBad : s.leakNeutral}>
                    {r.competitor ? `${r.competitor} wins it` : 'Nobody you track wins it'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
